import React from 'react';
import PropTypes from 'prop-types';

const GeoView = (props) =>{

    return <div>

    </div>

};

GeoView.propTypes = {
    notification: PropTypes.object
};


export default GeoView;


// WEBPACK FOOTER //
// ./src/components/UserNotifications/Templates/Geo.js